import { ICompany, ICompanyType } from '../../../types/record/company';
import {
  CompanyAPIRawSuccessResponseType,
  CompanyAPIRawValidationErrorType,
  ICompanyAPIValidationErrorFactory,
  ICompanyAPIValidationErrorType
} from '../../types/company/api-response';
import { nullableToStringList } from '../nullable-to-string-list';

export const ICompanyFromAPISuccessResponse = ({
  id,
  name,
  construction_company_id,
  project_count,
  model_count,
  can_be_deleted,
  created_at,
  updated_at
}: CompanyAPIRawSuccessResponseType): ICompanyType =>
  ICompany({
    id,
    name,
    koumutenId: construction_company_id,
    numProjects: project_count,
    numModels: model_count,
    canBeDeleted: can_be_deleted,
    dateCreated: new Date(created_at).getTime(),
    dateUpdated: new Date(updated_at).getTime()
  });

export const ICompanyAPIValidationError = ({
  name
}: CompanyAPIRawValidationErrorType): ICompanyAPIValidationErrorType =>
  ICompanyAPIValidationErrorFactory({
    name: nullableToStringList(name)
  });
